// src/core/db.js — capa de datos: cache en memoria de grupos.
//
// FASE 4 · F1.3.b. grupos y jugadores migraron a Supabase Postgres. db.js ya
// NO persiste grupos en localStorage — mantiene un CACHE en memoria que
// src/core/groups.js hidrata desde Postgres (cargarMisGrupos).
//
// getDB() / getNormalizedDB() conservan su firma exterior (CLAUDE.md §4):
// síncronas, devuelven `{ grupos, usuarios, memberships }`. Por dentro `grupos`
// es el cache Postgres-backed; los archivos no migrados (ranking.js, tribuna.js,
// perfil.js, rituales.js, pacto.js) los siguen leyendo sin saber que cambió la
// fuente. `usuarios` queda vacío — la entidad vive en Postgres (F1.3.a,
// getCurrentUser). `memberships` queda vacío — un membership ES una fila de
// `jugadores` (no hay tabla aparte); groups.js los sirve del cache.
//
// DT-Y cerrada: se eliminó el espejo localStorage de usuarios/memberships y los
// índices user_email_index/user_google_index que armaba ensureDataShape.

// ─── Cache de grupos (hidratado desde Postgres por groups.js) ──────────────
// Objeto de referencia estable: se muta in-place, nunca se reasigna, para que
// los `db.grupos` ya entregados por getDB() sigan apuntando al cache vivo.
const _gruposCache = {}

export const setGrupoEnCache = (grupo) => {
  if (grupo && grupo.code) _gruposCache[grupo.code] = grupo
}
export const quitarGrupoDeCache = (code) => { delete _gruposCache[code] }
export const limpiarGruposCache = () => {
  for (const k of Object.keys(_gruposCache)) delete _gruposCache[k]
}
export const getGrupoDeCache = (code) => _gruposCache[code] || null
export const getGruposCache = () => _gruposCache

// ─── Helpers de DB (firma exterior preservada) ─────────────────────────────

export const createEmptyDB = () => ({ grupos: {}, usuarios: {}, memberships: {} })

// getDB / getNormalizedDB: síncronas, devuelven el cache de grupos.
export const getDB = () => ({ grupos: _gruposCache, usuarios: {}, memberships: {} })
export const getNormalizedDB = getDB

export const normalizeEmail = (email) => (email || '').trim().toLowerCase()

// Conservada por firma exterior; en F1.3.b solo garantiza el shape mínimo.
// Ya no inventa filas de usuarios/memberships (DT-Y cerrada).
export const ensureDataShape = (db) => {
  db = db || {}
  db.grupos = db.grupos || {}
  db.usuarios = db.usuarios || {}
  db.memberships = db.memberships || {}
  return db
}

// saveDB / persistDB: no-ops. Las escrituras de grupos/jugadores van por
// Postgres (groups.js: crear_grupo / unirse_a_grupo / addJugador). Se conservan
// por firma exterior — los llamadores no migrados (pacto.js) no rompen.
export const saveDB = () => {}
export const persistDB = () => {}
